import { useTranslation } from 'i18n';
import { formatPrice } from 'utils/formatPrice';
import { deliveryRange } from 'utils/deliveryEstimate';

/** "Shipping & returns" (physical) / "How it works" (service, digital):
 * only what the store stated; nothing invented. */
export default function PolicyTab({ policies, listingType = 'PHYSICAL' }) {
  const { t } = useTranslation();
  const p = policies || {};
  if (listingType !== 'PHYSICAL') {
    return (
      <div className="space-y-2 text-sm text-text" data-testid="how-it-works">
        <p>{listingType === 'SERVICE' ? t('pdp.howService') : t('pdp.howDigital')}</p>
        {p.returnable === false && <p>{t('trust.noReturns')}</p>}
        {p.return_days && p.returnable !== false ? <p>{t('pdp.returnsLine', { count: p.return_days })}</p> : null}
      </div>
    );
  }
  const range = deliveryRange(p);
  const lines = [
    range && t('pdp.deliveryLine', { range }),
    p.free_shipping_threshold != null && t('trust.freeShippingOver', { amount: formatPrice(p.free_shipping_threshold) }),
    p.returnable === false ? t('trust.noReturns') : p.return_days && t('pdp.returnsLine', { count: p.return_days }),
    p.warranty_text && t('pdp.warrantyLine', { text: p.warranty_text }),
    p.cod_available != null && t('pdp.codLine', { value: p.cod_available ? t('policies.yes') : t('policies.no') }),
  ].filter(Boolean);
  if (!lines.length) return <p className="text-sm text-muted" data-testid="no-policies">{t('pdp.noPolicies')}</p>;
  return (
    <ul className="list-disc space-y-1 ps-5 text-sm text-text" data-testid="shipping-returns">
      {lines.map((l) => <li key={l}>{l}</li>)}
    </ul>
  );
}
